import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { t } from 'i18next';
import { SeeButton } from '../../../component/buttons';

function QuestionnaireAnswersTable({
    data,
    isLoading,
    count,
    paginationModel,
    setPaginationModel,
    rowsPerPageOptions
}) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const tableConfig = (navigate) => ({
        columns: [
            {
                field: 'questionnaireName',
                headerName: t('questionnaires.table.questionnaire'),
                flex: 1,
                renderCell: (params) => params.row?.questionnaire?.name || '—'
            },
            {
                field: 'ts',
                headerName: t('questionnaires.table.date'),
                width: 150,
                renderCell: (params) =>
                    params.row?.ts ? dayjs(params.row.ts).format('DD/MM/YYYY') : '—'
            },
            {
                field: 'filledBy',
                headerName: t('questionnaires.table.filledBy'),
                flex: 1,
                renderCell: (params) =>
                    params.row?.filled_by
                        ? `${params.row.filled_by.name} (${params.row.filled_by.role})`
                        : '—'
            },
            {
                field: 'actions',
                headerName: t('questionnaires.table.actions'),
                width: 150,
                renderCell: (params) => (
                    <SeeButton
                        size="small"
                        onClick={() =>
                            navigate(`/questionarios/resposta/${params.row.uuid}`)
                        }
                    >
                        <Typography variant="subtitle2">{t('users.see')}</Typography>
                    </SeeButton>
                )
            }
        ]
    });

    return (
        <DataGrid
            paginationMode="server"
            loading={isLoading}
            rows={data}
            getRowId={(row) => row.uuid}
            columns={tableConfig(navigate).columns}
            pageSizeOptions={rowsPerPageOptions}
            rowCount={count}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
        />
    );
}

QuestionnaireAnswersTable.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    count: PropTypes.number,
    paginationModel: PropTypes.object,
    setPaginationModel: PropTypes.func,
    rowsPerPageOptions: PropTypes.array
};

export default QuestionnaireAnswersTable;
